import React from 'react';

const SvgPin = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="47" viewBox="0 0 36 47">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g transform="translate(-1345 -483) translate(1345 483) matrix(1 0 0 -1 0 47)">
                            <path fill={props.color} fillRule="nonzero" d="M16.202 46.942c-3.743-.393-7.357-1.981-10.169-4.472-2.968-2.618-5.045-6.315-5.8-10.296-.313-1.687-.313-4.57.01-6.316.275-1.51.99-3.716 1.666-5.138 1.509-3.207 3.556-5.981 8.63-11.679 3.498-3.923 5.3-6.148 6.76-8.316.617-.911.754-.941 1.214-.215 1.098 1.745 3.39 4.58 7.024 8.678 3.37 3.804 4.575 5.266 5.946 7.168 3.39 4.746 4.938 9.787 4.419 14.484-.882 8.09-6.907 14.542-14.87 15.915-1.313.225-3.615.314-4.83.187z"/>
                            <circle cx="18" cy="29" r="13" fill="#FFF"/>
                        </g>
                    </g>
                </g>
            </g>
        </svg>

    );
};

export default SvgPin;